import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LandingHeader() {
  const navigate = useNavigate();
  return (
    <header className="fixed top-0 left-0 right-0 z-50 py-4 px-4 sm:px-6 lg:px-8 backdrop-blur-2xl bg-[#050505]/70 border-b border-zinc-800/50">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="text-white font-black text-2xl" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Flipping Friends
        </div>
        <button
          onClick={() => navigate('/login')}
          className="bg-gradient-to-r from-[#00D26A] to-[#FFD700] text-black px-6 py-2.5 rounded-full font-bold hover:opacity-90 transition-opacity shadow-[0_0_20px_rgba(0,210,106,0.2)]"
          data-testid="landing-header-login-btn"
        >
          Login / Start Scanning
        </button>
      </div>
    </header>
  );
}
